export const WINDOW_OBJ_MOCK = {
    location: {
        reload() {
            // ...do nothing
        },
        href: 'href',
    },
};
